import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { SelectVillage } from "../../../components/SelectVillage";
import { useState } from "react";
import { Dashboard } from "../../../enums/Dashboard";
import { bhpButtonSx } from "../../../styles/bhpStyles";
import { Asset } from "../../../data/Asset";


type SelectVillageDialogProps = {

    asset: Asset;
    dialogOpen: boolean;
    handleCancel: ( ) => void;
    handleOk: ( village : string ) => void;

};


export const SelectVillageDialog: React.FC< SelectVillageDialogProps > = ( props: SelectVillageDialogProps ) => {

    const { asset, dialogOpen, handleCancel, handleOk } = props;

    const [ canSubmit, setCanSubmit ] = useState< boolean >( false );
    const [ village, setVillage ] = useState< string >( '' );


    const handleCancelClick = () => {

        handleCancel( );
        setVillage( '' );
        setCanSubmit( false );

    };
    
    
    const handleOkClick = () => {

        handleOk( village );
        setVillage( '' );
        setCanSubmit( false );

    };

    
    const handleSelectVillage = ( villageCode : string ) => {

        setVillage( villageCode );
        setCanSubmit( true );

    };

    
    return (

        <Dialog
            sx={{ '& .MuiDialog-paper': { maxHeight: 435, width: '500px' } }}
            open={ dialogOpen }>
            <DialogTitle>Select Cardholder Current Location</DialogTitle>
            <DialogContent dividers>
                
                <SelectVillage asset={ asset } dashboard={ Dashboard.VillageWiFi } onSelectVillage={ handleSelectVillage } />

            </DialogContent>
            <DialogActions>
                <Button onClick={ handleOkClick } sx={{ ...bhpButtonSx, width: '100px' }} disabled={ !canSubmit }>
                    Ok
                </Button>
                <Button autoFocus onClick={ handleCancelClick } sx={{ ...bhpButtonSx, width: '100px' }}>
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>

    );

};